import { AbstractControl, ValidatorFn } from '@angular/forms'
import { LogicFn, PathKind, SchemaPath, SchemaPathRules, validate, ValidationError } from '@angular/forms/signals'

/**
 * Ajaa reaktiivisten lomakkeiden validaattorin Signal Forms -kentälle. Validaattorin virheavaimet tulevat virheiden
 * lajeiksi (`kind`), joten käännösavaimet pysyvät samoina kuin reaktiivisessa lomakkeessa.
 */
export function validoiReaktiivisesti<TValue, TPathKind extends PathKind = PathKind.Root>(
  polku: SchemaPath<TValue, SchemaPathRules.Supported, TPathKind>,
  validaattori: ValidatorFn,
  asetukset?: { when?: LogicFn<TValue, boolean, TPathKind> },
): void {
  validate(polku, konteksti => {
    if (asetukset?.when && !asetukset.when(konteksti)) {
      return null
    }
    const virheet = validaattori({ value: konteksti.value() } as AbstractControl)
    return virheet ? Object.keys(virheet).map((laji): ValidationError => ({ kind: laji })) : null
  })
}
